import React from 'react'
import SideMenuNavUi from 'common/components/entities/Menu/components/Mobile/Side/ui/SideMenuNavUi'
import SideMenuUi from 'common/components/entities/Menu/components/Mobile/Side/ui/SideMenuUi'
import MobileMenuItem from 'common/components/entities/Menu/components/Mobile/components/MobileMenuItem'
import { MenuItemInterface } from 'common/components/entities/Menu/types/MenuInterface'
import { AlignSelfType } from 'common/types/styleTypes'
import { isBlogReplacementPlaceholder } from 'common/utils/blogReplacementsUtils'
import { FontProps } from 'common/utils/styleUtilsNew'

type SideMenuProps = {
  attrId: string
  menuAttrId: string
  items: MenuItemInterface[]
  alignSelf: AlignSelfType
  mobileAlignSelf?: AlignSelfType
  sideMenuBackgroundColor?: string
  activeColor: string
  mobileActiveColor?: string
  lineHeight?: number
  mobileLineHeight?: number
  opened: boolean
  itemUnderlineColor?: string
  mobileItemUnderlineColor?: string
  forceVisible?: boolean
  spacing?: number
  subMenuSpacing?: number
  isEditing?: boolean
} & FontProps

function SideMenu({
  attrId,
  menuAttrId,
  items,
  alignSelf,
  mobileAlignSelf,
  sideMenuBackgroundColor,
  activeColor,
  mobileActiveColor,
  lineHeight,
  mobileLineHeight,
  opened = false,
  itemUnderlineColor,
  mobileItemUnderlineColor,
  forceVisible = false,
  fontSize,
  mobileFontSize,
  color,
  fontFamily,
  fontWeight,
  fontStyle,
  mobileColor,
  mobileFontFamily,
  mobileFontWeight,
  mobileFontStyle,
  spacing,
  subMenuSpacing,
  isEditing,
}: SideMenuProps) {
  return (
    <SideMenuUi
      id={menuAttrId}
      opened={opened}
      alignSelf={alignSelf}
      mobileAlignSelf={mobileAlignSelf}
      forceVisible={forceVisible}
      sideMenuBackgroundColor={sideMenuBackgroundColor}
    >
      <SideMenuNavUi spacing={spacing}>
        {items
          .filter(item => !isBlogReplacementPlaceholder(item.link))
          .map((item, index) => (
            <MobileMenuItem
              key={`${attrId}-item-${index}-${item.link || item.text}`}
              attrId={attrId}
              item={item}
              index={index}
              activeColor={activeColor}
              mobileActiveColor={mobileActiveColor}
              mobileUnderlineColor={mobileItemUnderlineColor}
              underlineColor={itemUnderlineColor}
              fontSize={fontSize}
              mobileFontSize={mobileFontSize}
              fontFamily={fontFamily}
              fontWeight={fontWeight}
              fontStyle={fontStyle}
              mobileFontFamily={mobileFontFamily}
              mobileFontWeight={mobileFontWeight}
              mobileFontStyle={mobileFontStyle}
              lineHeight={lineHeight}
              mobileLineHeight={mobileLineHeight}
              color={color}
              mobileColor={mobileColor}
              spacing={subMenuSpacing}
              isEditing={isEditing}
            />
          ))}
      </SideMenuNavUi>
    </SideMenuUi>
  )
}

export default SideMenu
